import { render, staticRenderFns } from "./ReservaButacasComponent.vue?vue&type=template&id=2bf31a22"
import script from "./ReservaButacasComponent.vue?vue&type=script&lang=js"
export * from "./ReservaButacasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports